import { Injectable, Inject } from '@angular/core';
import { NewHttpClient } from '../interceptor.service';
//import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';
import { INJECTION_TOKEN } from '../../app.config';

@Injectable()
export class WarehousesRequests {
  constructor(
    @Inject(INJECTION_TOKEN) public config: any,
    private http: NewHttpClient
  ) {}

  /**
   * Create a warehouse
   *
   * @param data
   */
  create(data: any): Observable<any> {
    let url = `${this.config.warehouse_url}`;
    return this.http.post(url, data);
  }

  /**
   * Get warehouses
   *
   * @param data
   */
  get(data?: any): Observable<any> {
    let params = '';

    if (data) {
      let keys = Object.keys(data);
      keys.forEach(key => {
        if (!params.length) params = `?${key}=${data[key]}`;
        else params += `&${key}=${data[key]}`;
      });
    }

    let url = `${this.config.warehouse_url}/${params}`;
    return this.http.get(url);
  }

  /**
   * Get warehouse by id
   *
   * @param id
   */
  getOne(id: string): Observable<any> {
    let url = `${this.config.warehouse_url}/${id}`;
    return this.http.get(url);
  }
}
